function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#a0a2ad",
  d: "M7.829 9.243a5.002 5.002 0 0 0 6.928 6.928l-1.463-1.463c-.391.187-.83.292-1.294.292-1.66 0-3-1.34-3-3 0-.464.105-.903.292-1.294L7.829 9.243zm9.155 9.155A11.753 11.753 0 0 1 12 19.5c-5 0-9.27-3.11-11-7.5a11.889 11.889 0 0 1 4.224-5.362L2 3.414 3.414 2 21.8 20.385l-1.414 1.414-3.4-3.4zM9.24 4.825c.885-.213 1.81-.325 2.76-.325 5 0 9.27 3.11 11 7.5a11.871 11.871 0 0 1-2.599 3.987l-3.432-3.432a5.002 5.002 0 0 0-5.525-5.525L9.24 4.826z",
  fillRule: "evenodd"
});

var SvgEyeClosed = function SvgEyeClosed(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), React.createElement("title", null, title), _ref2);
};

export default SvgEyeClosed;